import { useMutation, useQueryClient } from '@tanstack/react-query';

import { addFolderItem, removeFolderItem } from '../fetchers/folderItems';
import { folderKeys } from '../folder.keys';

import { useSyncFolder } from './useSyncFolder';

/**
 * 퀴즈를 이 폴더로 옮긴다. 어디 있었든(내 퀴즈·다른 폴더) 서버가 옮긴다.
 *
 * 응답은 도착 폴더뿐이라 출발 폴더 상세는 따로 무효화한다 — 개수가 줄고, 비면 서버가 비공개로 바꾼다.
 * 출발 폴더를 호출부마다 넘기지 않고 열려 있는 상세 전부를 무효화한다. 활성 상세는 많아야 한두 개다.
 */
export const useAddFolderItem = () => {
  const queryClient = useQueryClient();
  const sync = useSyncFolder();
  return useMutation({
    scope: { id: 'folder-items' },
    mutationFn: ({
      id,
      quizsetId,
      confirmSourcePublication = false,
    }: {
      id: string;
      quizsetId: string;
      confirmSourcePublication?: boolean;
    }) => addFolderItem(id, quizsetId, confirmSourcePublication),
    onSuccess: folder => {
      sync(folder);
      void queryClient.invalidateQueries({ queryKey: folderKeys.details() });
    },
  });
};

export const useRemoveFolderItem = () => {
  const sync = useSyncFolder();
  return useMutation({
    scope: { id: 'folder-items' },
    mutationFn: ({ id, quizsetId }: { id: string; quizsetId: string }) =>
      removeFolderItem(id, quizsetId),
    onSuccess: folder => sync(folder),
  });
};
